/* eslint-disable */
// @ts-nocheck

import React, { useState } from 'react'

import { TruckIcon } from '@heroicons/react/24/outline'

import Breadcrumb from '@/components/navigation/Breadcrumb'

import { NewPurchaseOrderModal } from './components/NewPurchaseOrderModal'
import { FiltersRow } from './filters/FiltersRow'
import { getColumns } from './table/Columns'
import { DataTable } from './table/DataTable'
import { TableContextProvider } from './table/TableContext'

const PurchaseOrderList: React.FC = () => {
  // Eliminada restricción de entorno de desarrollo
  const [showModal, setShowModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const handleNewPurchaseOrder = () => {
    setShowModal(true)
  }

  const _handleCloseModal = () => {
    setShowModal(false)
    setShowEditModal(false)
  }

  const handleCloseEditModal = () => {
    setShowEditModal(false)
  }

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false)
  }

  return (
    <div>
      <Breadcrumb
        icon={<TruckIcon className="h-6 text-gray-500" />}
        paths={[{ name: 'Logística' }, { name: 'Órdenes de compra' }]}
      />
      <FiltersRow />
      <TableContextProvider>
        <DataTable
          columns={getColumns()}
          onClose={handleCloseEditModal}
          onCloseDelete={handleCloseDeleteModal}
          onNewPurchaseOrder={handleNewPurchaseOrder}
          showDeletePurchaseOrder={showDeleteModal}
          showEditPurchaseOrder={showEditModal}
        />
      </TableContextProvider>

      <NewPurchaseOrderModal onOpenChange={setShowModal} open={showModal} />
    </div>
  )
}

export default PurchaseOrderList
